var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderWithoutTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8584 4H7.71387V6H9.8584V8H5.71387V6H3.71387V20H17.7139V11.9375H19.7139V21.0068C19.7137 21.5553 19.2681 22 18.7197 22H2.70703C2.15847 22 1.71302 21.5552 1.71289 21.0068V4.99316C1.71302 4.44463 2.15866 4 2.70703 4H5.71387V2H9.8584V4Z",
    fill: "#525256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5994 4.63772L20.5994 8.29449C20.5994 9.69265 19.4659 10.8261 18.0678 10.8261C16.6696 10.8261 15.5362 9.69265 15.5362 8.29449L15.5362 4.35643C15.5362 3.57968 14.9065 2.94999 14.1297 2.94999C13.353 2.94999 12.7233 3.57968 12.7233 4.35643L12.7233 8.10923C13.3788 8.34092 13.8484 8.96608 13.8484 9.70093C13.8484 10.633 13.0928 11.3887 12.1607 11.3887C11.2285 11.3887 10.473 10.633 10.473 9.70093C10.473 8.96608 10.9426 8.34092 11.5981 8.10923L11.5981 4.35643C11.5981 2.95825 12.7315 1.82483 14.1297 1.82483C15.5279 1.82483 16.6613 2.95826 16.6613 4.35643L16.6613 8.29449C16.6613 9.07125 17.291 9.70093 18.0678 9.70093C18.8445 9.70093 19.4742 9.07125 19.4742 8.29449L19.4742 4.63772L17.7865 4.63772L20.0368 1.82483L22.2871 4.63772L20.5994 4.63772ZM12.1607 9.13835C11.85 9.13835 11.5981 9.39023 11.5981 9.70093C11.5981 10.0116 11.85 10.2635 12.1607 10.2635C12.4714 10.2635 12.7233 10.0116 12.7233 9.70093C12.7233 9.39023 12.4714 9.13835 12.1607 9.13835Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderWithoutTraffic);
export default __webpack_public_path__ + "static/media/order-without-traffic.ee8b78442e19fae430f40c42adb1dfc2.svg";
export { ForwardRef as ReactComponent };